/**
 * @generated SignedSource<<547a9f36778514e828fcbd5b59308c89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type vehicletype = "C18" | "C36" | "C93" | "DOCK_G27" | "DOCK_G47" | "E1" | "R1" | "R3" | "R47" | "R47_ISP" | "R47_XAVIER" | "R71" | "SIMULATOR" | "UNKNOWN" | "W17" | "%future added value";
export type VehiclesListAdminQuery$variables = {
  count: number;
  cursor?: string | null;
  organizationUuid?: string | null;
  releaseUuid?: string | null;
  searchTerm?: string | null;
  vehicleTypes?: ReadonlyArray<vehicletype> | null;
};
export type VehiclesListAdminQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"VehiclesList_vehicles">;
};
export type VehiclesListAdminQuery = {
  response: VehiclesListAdminQuery$data;
  variables: VehiclesListAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationUuid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "releaseUuid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vehicleTypes"
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "organizationUuid",
    "variableName": "organizationUuid"
  },
  {
    "kind": "Variable",
    "name": "releaseUuid",
    "variableName": "releaseUuid"
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  },
  {
    "kind": "Variable",
    "name": "vehicleTypes",
    "variableName": "vehicleTypes"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skydioSerial",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VehiclesListAdminQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "VehiclesList_vehicles"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "VehiclesListAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "VehicleConnection",
        "kind": "LinkedField",
        "name": "vehicles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Vehicle",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vehicleId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organizationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vehicleType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Release",
                    "kind": "LinkedField",
                    "name": "release",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "releaseKey",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "versionString",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOnline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dock",
                    "kind": "LinkedField",
                    "name": "dock",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dockId",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccessPoint",
                    "kind": "LinkedField",
                    "name": "accessPoint",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "filters": [
          "searchTerm",
          "organizationUuid",
          "releaseUuid",
          "vehicleTypes"
        ],
        "handle": "connection",
        "key": "VehiclesList_vehicles",
        "kind": "LinkedHandle",
        "name": "vehicles"
      }
    ]
  },
  "params": {
    "cacheID": "d568c8b95585bc98d01088424c9f2489",
    "id": null,
    "metadata": {},
    "name": "VehiclesListAdminQuery",
    "operationKind": "query",
    "text": "query VehiclesListAdminQuery(\n  $count: Int!\n  $cursor: String\n  $searchTerm: String\n  $organizationUuid: String\n  $releaseUuid: String\n  $vehicleTypes: [vehicletype!]\n) {\n  ...VehiclesList_vehicles\n}\n\nfragment VehiclesList_vehicles on Query {\n  vehicles(searchTerm: $searchTerm, organizationUuid: $organizationUuid, releaseUuid: $releaseUuid, vehicleTypes: $vehicleTypes, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        id\n        uuid\n        name\n        displayName\n        skydioSerial\n        vehicleId\n        organizationId\n        vehicleType\n        organization {\n          name\n          id\n        }\n        release {\n          releaseKey\n          name\n          versionString\n          id\n        }\n        isOnline\n        dock {\n          displayName\n          dockId\n          id\n        }\n        accessPoint {\n          displayName\n          skydioSerial\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ff794cff64706ae20862dcf24a2a7ee";

export default node;
